import { ArrowUpOutlined, GiftOutlined, MailOutlined, SwapOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function ServiceGrid() {
    const { t } = useTranslation('home');
    return (
        <section className="section">
            <div className="section-head">
                <h2>{t('services.title')}</h2>
            </div>
            <div className="services">
                <Link className="service-card live" to="/explore">
                    <span className="service-icon service-icon--gift">
                        <GiftOutlined />
                    </span>
                    <div>
                        <h3>{t('services.giftCards.title')}</h3>
                        <p>{t('services.giftCards.description')}</p>
                    </div>
                    <span className="end">
                        <ArrowUpOutlined />
                    </span>
                </Link>
                <Link className="service-card live" to="/red-packet">
                    <span className="service-icon service-icon--packet">
                        <MailOutlined />
                    </span>
                    <div>
                        <h3>{t('services.redPacket.title')}</h3>
                        <p>{t('services.redPacket.description')}</p>
                    </div>
                    <span className="end">
                        <ArrowUpOutlined />
                    </span>
                </Link>
                <div className="service-card">
                    <span className="service-icon service-icon--wallet">
                        <SwapOutlined />
                    </span>
                    <div>
                        <h3>{t('services.prediction.title')}</h3>
                        <p>{t('services.prediction.description')}</p>
                    </div>
                    <span className="badge end">{t('services.comingLater')}</span>
                </div>
            </div>
        </section>
    );
}

export default ServiceGrid;
